import type { ContactDialogType } from "@/components/contact-dialog"
import { httpClient } from "@/utils/api"
import type { SuccessData } from "@/utils/api"
import { useMutation } from "@tanstack/react-query"
import type { UseMutationOptions } from "@tanstack/react-query"
import type { AxiosError, AxiosResponse } from "axios"

interface SendContactEmailParams {
  message: string
  organizationId: string
  type: ContactDialogType
}

const sendContactEmail = async ({
  message,
  organizationId,
  type,
}: SendContactEmailParams): Promise<AxiosResponse<SuccessData>> => {
  const response: AxiosResponse<SuccessData> = await httpClient.post(
    "/api/v1/contact_us",
    { text: message, type, organization_id: organizationId }
  )

  return response
}

export const useSendContactEmail = (
  options?: UseMutationOptions<
    AxiosResponse<SuccessData>,
    AxiosError,
    SendContactEmailParams
  >
) => {
  const useMutationOptions = {
    ...options,
    mutationFn: async (emailParams: SendContactEmailParams) =>
      sendContactEmail(emailParams),
  }

  const { data, isError, isPending, isSuccess, mutateAsync } =
    useMutation(useMutationOptions)

  return {
    sendContactEmail: mutateAsync,
    sendContactEmailData: data,
    sendContactEmailIsError: isError,
    sendContactEmailIsLoading: isPending,
    sendContactEmailIsPending: isPending,
    sendContactEmailIsSuccess: isSuccess,
  }
}
